import * as React from 'react';
import { Separator } from './separator';
import { cn } from '../../lib/utils';

interface SettingsSectionProps {
  label: string;
  description?: string;
  children: React.ReactNode;
  showSeparator?: boolean;
  className?: string;
}

export const SettingsSection = React.forwardRef<
  HTMLDivElement,
  SettingsSectionProps
>(({ label, description, children, showSeparator = true, className }, ref) => (
  <>
    <div
      ref={ref}
      className={cn(
        'flex justify-between',
        description ? 'items-start' : 'items-center',
        className,
      )}
    >
      <div className="space-y-1">
        <p className="font-medium">{label}</p>
        {description && <p className="helper-text">{description}</p>}
      </div>
      <div className="flex gap-4">{children}</div>
    </div>
    {showSeparator && <Separator />}
  </>
));
SettingsSection.displayName = 'SettingsSection';

interface SettingsLayoutProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
}

export const SettingsLayout = React.forwardRef<
  HTMLDivElement,
  SettingsLayoutProps
>(({ children, title, className }, ref) => (
  <div
    ref={ref}
    className={cn('h-full overflow-y-auto bg-transparent', className)}
  >
    <div className="max-w-4xl space-y-4 px-4 sm:px-6 md:px-8 pt-4 sm:pt-6 md:pt-8 pb-8">
      {title && <h1 className="text-lg font-medium">{title}</h1>}
      {children}
    </div>
  </div>
));
SettingsLayout.displayName = 'SettingsLayout';

export const SettingsTitle = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, children, ...props }, ref) => (
  <h1 ref={ref} className={cn('text-lg font-medium', className)} {...props}>
    {children}
  </h1>
));
SettingsTitle.displayName = 'SettingsTitle';
